// Models
/** Extension fields for the copilot */ export class CopilotExtensions {
    constructor(loopPageUrl, id, workflowSubmitTimeStamp, isAiTask){
        this.loopPageUrl = loopPageUrl;
        this.id = id;
        this.workflowSubmitTimeStamp = workflowSubmitTimeStamp;
        this.isAiTask = isAiTask;
    }
}
